import { ParamedicalProfession } from '@dreryk/egabinet-personnel-frontend-api';

import { useTranslate } from '@dreryk/react-common';

import { createMedicalRoleVisitor, useGetCurrentPractitionerGlobalState } from '~libs.shared.account';

import { translationKeys } from './translations';

export const isParamedicalProfession = (name: string): name is ParamedicalProfession => {
   return name in translationKeys.paramedicalProfessionsMap;
};

export const useGetEducationalMaterialTags = (): { tags: string[] } => {
   const translate = useTranslate();
   const currentPractitioner = useGetCurrentPractitionerGlobalState();

   const tags = createMedicalRoleVisitor(currentPractitioner)<string[]>({
      visitDoctor: ({ doctorSpecialties }) => doctorSpecialties.map(({ medicalSpecialty }) => medicalSpecialty.name),
      visitParamedic: (paramedicalProfessions) =>
         paramedicalProfessions.reduce<string[]>((acc, profession) => {
            if (isParamedicalProfession(profession)) {
               acc.push(translate(translationKeys.paramedicalProfessionsMap[profession]));
            } else {
               acc.push(translate(translationKeys.paramedicalProfessionsMap.UNKNOWN));
            }

            return acc;
         }, []),
      visitUnknown: () => [],
   });

   return {
      tags: tags,
   };
};
